<div class="row mx-0 justify-content-between gap-2 align-items-center">
	<div class="col px-0 rounded image-container" [ngClass]="{ 'col-sm-8': ad?.images.length >= 3 }">
		<img [src]="ad?.images[0]?.name" class="large-image h-100" />

		<div
			class="mb-2 mx-2"
			[ngClass]="{ 'button-container-rtl': localeService.lang !== 'en', 'button-container': localeService.lang === 'en' }"
			*ngIf="ad?.sold === '0'"
		>
			<button mat-button class="w-100 fg-white fs-11px fw-400" [disableRipple]="true" (click)="onOpenGallery($event, ad)">
				<img
					[src]="'assets/images/view-all-photos-icon.svg' | s3Image"
					class="mb-2px"
					[ngClass]="{ 'me-2': localeService.lang === 'en', 'ms-2': localeService.lang !== 'en' }"
				/>
				<span>{{ localeService.translations['n703'] }}</span>
			</button>
		</div>
		<!-- Favorite button -->
		<!-- Button showing when not marked favorite -->
		<app-button
			class="favorite mb-2"
			customClass="bg-darkest-grey"
			[btnType]="buttonType.MINI_FAB"
			[isStopPropagation]="true"
			(clicked)="onWatch(ad)"
			*ngIf="ad.watching === '0'"
		>
			<mat-icon class="favorite" icon>favorite_border</mat-icon>
		</app-button>

		<!-- Button showing when  marked favorite -->
		<app-button
			class="favorite mb-2"
			customClass="bg-darkest-grey"
			[btnType]="buttonType.MINI_FAB"
			[isStopPropagation]="true"
			(clicked)="onWatch(ad)"
			*ngIf="ad.watching === '1'"
		>
			<mat-icon class="favorite" [class.favorite--primary]="ad.watching === '1'" icon>favorite</mat-icon>
		</app-button>
	</div>

	<div class="col px-0 small-image" *ngIf="ad?.images?.length >= 3 && viewport.type !== 'mobile'">
		<div *ngFor="let imgUrl of [ad?.images[1]?.name, ad?.images[2]?.name]; let i = index" class="rounded mb-2 sub-image position-relative">
			<img [src]="imgUrl" class="other-images rounded" [class.gallery-img]="i === 1" />
		</div>
	</div>
</div>

<a class="row mx-0 gap-1 on-desktop mt-1" *ngIf="ad?.images?.length >= 3 && viewport.type === 'mobile'">
	<div class="col px-0">
		<img x class="position-relative w-100 other-images rounded" [src]="ad?.images[1]?.name" [alt]="ad?.title" />
	</div>

	<div class="col px-0">
		<img class="other-images rounded" [src]="ad?.images[2]?.name" [alt]="ad?.title" />
	</div>
</a>
